"use client";
import dynamic from "next/dynamic";

const LiveLecture1050CSR = dynamic(() => import("./index"), {
  ssr: false,
});

export default LiveLecture1050CSR;
